import { useMemo } from "react";
import type { ChannelName, ChannelStatus } from "../../../../../channels/types";
import type { GetPersonsInSegmentJsonPerson } from "../../../../types/segment-schema";

export function useOptedOutPersons(
  channel: ChannelName,
  data: GetPersonsInSegmentJsonPerson[],
): GetPersonsInSegmentJsonPerson[] {
  return useMemo(() => {
    if (!channel || data.length === 0) return [];

    return data.filter((person) => {
      const channelInfo = (person.channels as Record<NonNullable<ChannelName>, ChannelStatus>)[
        channel
      ];
      return channelInfo?.opted_out;
    });
  }, [data, channel]);
}
